import { MyParticipant } from './my-participant';

export class Room {
  public constructor(public localParticipant: MyParticipant) {}
}
